import React from 'react'
import "./DescriptionBox.css"

const DecsriptionBox = () => {
  return (
    <div className='descriptionbox'>
        <div className="decriptionbox-navigator">
            <div className="descriptionbox-nav-box">
                Decription
            </div>
            <div className="descriptionbox-nav-box">
                Reviews (22)
            </div>
        </div>
        <div className="decriptionbox-description">
            <p>PrimeCosmo is a modern cosmetic brand focused on natural care and premium quality. We specialize in hair oils, beard oils, and goated soaps that are safe, effective, and gentle for daily use. Each product is crafted with carefully selected ingredients to provide natural nourishment for your hair, beard, and skin, delivering long-lasting results.</p>
            <p>At PrimeCosmo, our goal is not just to sell products, but to promote a confident and self-care lifestyle. Whether it’s strong hair growth, healthy beard maintenance, or smooth, refreshed skin, PrimeCosmo products offer a pure, powerful, and trusted grooming experience.</p>
        </div>
    </div>
  )
}

export default DecsriptionBox
